<template>
	<div class="independent-wrapper">
		<div class="content" ref="box">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 客户管理 > 用户管理
			</div>
			<div class="contentLeft">
				<div class="tab-container tab">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index)">
							{{ item }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">
							<el-form-item class="el-form-item-line " label="机构">
								<el-select v-model="searchData.hos" filterable placeholder="请选择">
									<el-option v-for="item in hospitalList" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="el-form-item-line " label="用户姓名">
								<el-input v-model="searchData.name" placeholder="请输入用户姓名查询"></el-input>
							</el-form-item>

							<el-form-item class="el-form-item-line date" label="注册时间">
								<el-form-item class="line" prop="startDate">
									<el-date-picker size="large" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
										placeholder="开始日期" v-model="searchData.startDate"></el-date-picker>
								</el-form-item>
								<span class="line line-10">-</span>
								<el-form-item class="line endDate" prop="endDate">
									<el-date-picker size="large" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="结束日期"
										v-model="searchData.endDate"></el-date-picker>
								</el-form-item>
							</el-form-item>
							<el-form-item class="el-form-item-line " label="手机号码">
								<el-input v-model="searchData.phone" placeholder="请输入手机号码查询"></el-input>
							</el-form-item>


							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large" :icon="RefreshRight" @click="reset">重置</el-button>
								<el-button size="large" :icon="Search" class="searchBtn" @click="onSearch">查询</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%;cursor: pointer;"
							:data="tableListData" @cell-click="viewReport">
							
							<el-table-column align="center" label="编码" prop="number">
							</el-table-column>
							<el-table-column align="center" label="姓名" prop="name" width="80">
							</el-table-column>
							<el-table-column align="center" label="手机号" prop="phone">
								
								<template #default="{row}">
									<div>
										{{ row.phone ? row.phone : "暂无" }}
									</div>
								</template>
							</el-table-column>
							<el-table-column align="center" label="脉象结果" prop="pulse">
								<template #default="{row}">
									<div v-html="row.pulse"></div>
								</template>
							</el-table-column>
							<el-table-column align="center" label="测量时间" prop="visitTime">
							</el-table-column>
							<el-table-column align="center" label="操作" width="100">
								<span class="editor">
									查看详情
								</span>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange"
										:current-page="currentPage" :page-size="10"
										layout="prev, pager, next, jumper" :total="total">
									</el-pagination>
								</div>
								<div class="data">
									共<span>{{ totalPage }}</span>页/<span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import globle from "../../globle/globle";
	import { RefreshRight,Search } from '@element-plus/icons-vue'
	export default {
		data() {
			return {
				RefreshRight,
				Search,
				searchData: {
					hos: "", //机构
					name: "", //
					phone: "", //医案分类
					softVersion: "", //软件版本
					startDate: "", //开始日期
					endDate: "", //结束日期
				},
				tabList: ["用户管理", "机构管理"],
				currentTabIndex: 0,
				role: "",
				currentPage: 1, //当前页
				totalPage: 1, //总页数
				total: 1, //总数据
				tableListData: [],
				scroll: 0,
				hospitalList: []
			};
		},

		methods: {
			//获取机构列表
			getHospitalList(name) {
				this.$post("/business/user/hospital/list")
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.hospitalList = res.data.data;
							this.hospitalList[0] = "请选择";
						} else {
							alert(res.data.msg);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//路由切换
			goOther(index) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/userManagement/userManagement",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/userManagement/insManagement",
					});
				}
			},
			//重置
			reset() {
				this.searchData = {
					hos: "", //机构
					name: "", //
					phone: "", //医案分类
					softVersion: "", //软件版本
					startDate: "", //开始日期
					endDate: "", //结束日期
				};
				this.gethistroyList();
			},
			//搜索功能
			onSearch() {
				if (this.searchData.endDate < this.searchData.startDate) {
					alert("结束时间不能小于开始时间");
					return false;
				}
				this.currentPage = 1;
				this.gethistroyList();
			},

			//获取历史列表
			gethistroyList() {
				this.$applicationJson("/business/pulse/result/paging", {
						current: this.currentPage,
						orderBy: "",
						params: {
							hos: this.searchData.hos,
							name: this.searchData.name,
							phone: this.searchData.phone,
							statDateL: this.searchData.startDate,
							statDateR: this.searchData.endDate
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							this.total = res.data.data.total;
							this.totalPage = res.data.data.pages;
						} else {
							alert(res.data.msg);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//页码跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				this.gethistroyList();
			},
			//查看详情
			viewReport(item) {
				this.$router.push({
					path: "/userManagement/userManagementDetail",
					query: {
						id: item.id
					},
				});
			},
		},
		created() {
			this.$nextTick(() => {
				let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let role = loginInfo.role;
				this.role = role;
				this.getHospitalList();
				this.gethistroyList();
			});
		},
		activated() {
			this.$refs.box.scrollTop = this.scroll;
		}
		
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {
			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.demo-form-inline {
					margin-top: 10px;
				}

				.search-con {
					@media screen and (min-width: 0px) and (max-width: 1060px) {
						height: 180px;
						width: 100%;
					}
					@media screen and (min-width: 1060px) and (max-width: 1280px) {
						height: 130px;
						width: 100%;
					}
					@media (min-width: 1280px) {
						width: 100%;
						height: 130px;
					}
					@media (min-width: 1480px) {
						width: 100%;
						height: 70px;
					}
					@media screen and (min-width: 1480px) and (max-width: 1856px) {
						height: 130px;
						width: 100%;
					}
					@media (min-width: 1920px) {
						width: 100%;
						height: 70px;
					}
				}
			}
		}
		.editor {
			cursor: pointer;
			color: #679ff6;
		}
	}
</style>
